import Translations from '../Translations';
import React, {
    useState,
} from 'react';
import {
    Modal,
    Button,
    Icon,
} from 'semantic-ui-react';
import * as LottiePlayer from "@lottiefiles/lottie-player";

import selectionAnimationFile from '../../assets/selecting.json';
import saveSelectionDemoAFile from '../../assets/save_selection_demo.json';
import selectionCloseDemoAFile from '../../assets/selection_close_demo.json';
import walletDemoAFile from '../../assets/wallet_demo.json';

const ModalHowToSelect = (props) => {

    const [open, setOpen] = useState(true);
    const [counter, setCounter] = useState(0);


    const getAnimationFile = (c) => {
        if (c === 0) return JSON.stringify(walletDemoAFile);
        if (c === 1) return JSON.stringify(saveSelectionDemoAFile);
        if (c === 2) return JSON.stringify(selectionCloseDemoAFile);
        return JSON.stringify(selectionAnimationFile);
    }

    const getDescription = () => {
        if (counter === 0) {
            return (
                <div>
                    <h4><Translations text="walletbalancewidget.walletbalance" backup={"Wallet balance"} /></h4>
                    <p><Translations text="selection.guide_wallet_description" backup={"Your wallet balance and cart total is reflected at the bottom of the page."} /></p>
                </div>
            );
        }
        if (counter === 1) {
            return (
                <div>
                    <h4><Translations text="selection.guide_saving_title" backup={"Saving Selection"} /></h4>
                    <p>
                        <Translations text="selection.guide_saving_description" backup={"After selecting your option, it will be automatically saved. To go back to the home page, click \"<\""} />
                    </p>
                </div>
            );
        }
        if (counter === 2) {
            return (
                <div>
                    <h4><Translations text="selection.guide_closing_title" backup={"Selection Closes"} /></h4>
                    <p><Translations text="selection.guide_closing_description" backup={"Once the selection closes, your last recorded selection will be confirmed and cannot be changed."} /></p>
                </div>
            );
        }
        return (
            <div>
                <h4>
                    Making a selection
                </h4>
                <p>
                    To make your selection, click on the <Icon name="edit"/>button under each policy to view the available options. 
                </p>
                <p>
                    Click save to confirm your selection.
                </p>
            </div>
        );
    }

    const updateCounter = () => {
        if (counter === 2) {
            setOpen(false);
        } else {
            const animationFile = getAnimationFile(counter + 1);
            const player = document.querySelector("lottie-player");
            player.load(animationFile);
            setCounter(counter + 1);
        }
    }

    return (
        <Modal
            open={open}
            dimmer="inverted"
            // trigger={(
            //     <Button 
            //         size="tiny"
            //         content="?"
            //         // icon="info circle"
            //         onClick={() => setOpen(true)}
            //         // style={{padding: 10}}
            //     />
            // )}
        >
            <Modal.Header><Translations text="selection.guide_title" backup={"How To Select"} /></Modal.Header>
            <Modal.Content>
                <lottie-player
                    autoplay
                    loop
                    mode="normal"
                    speed={1}
                    src={JSON.stringify(walletDemoAFile)}
                />
                <div style={{marginTop: 16}}>
                    {getDescription()}
                </div>
                <Button
                    fluid
                    primary
                    content={(counter < 2) ? <Translations text="common.next" backup={"Next"} /> : <Translations text="common.okay" backup={"Ok"} />}
                    style={{marginTop: 15}}
                    onClick={updateCounter}
                />
                <Button
                    fluid
                    secondary
                    content={<Translations text="common.skip" backup={"Skip"} />}
                    disabled={(counter > 1)}
                    style={{marginTop: 15}}
                    onClick={() => setOpen(false)}
                />
            </Modal.Content>
        </Modal>
    );
};

export default ModalHowToSelect;
